import { render } from "./boilMedicine.vue?vue&type=template&id=57e5c9ec&scoped=true"
import script from "./boilMedicine.vue?vue&type=script&lang=js"
export * from "./boilMedicine.vue?vue&type=script&lang=js"

import "./boilMedicine.vue?vue&type=style&index=0&id=57e5c9ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57e5c9ec"

export default script